export const menuItems = [
	// {
	// 	title: 'Campagnes',
	// 	url: '/app/campaigns',
	// 	name: 'campaigns',
	// 	items: [
	// 		{
	// 			title: 'Campagne toevoegen',
	// 			url: '/app/campaigns/create',
	// 		}
	// 	]
	// },
	{
		title: 'Promotie toevoegen',
		url: '/app/promotions/create',
		name: 'promotions',
		items: [
			// {
			// 	title: 'Promotie toevoegen',
			// 	url: '/app/promotions/create',
			// }
		]
	},
	{
		title: 'Campagnes',
		url: '/app/campaigns',
		name: 'campaigns',
		items: []
	},
	{
		title: 'Statistieken',
		url: '/app/stats/compare',
		name: 'statistics',
		items: [
			{
				title: 'Gearchiveerd',
				url: '/app/stats/archived',
			}
		]
	},
	{
		title: 'Instellingen',
		url: '/app/settings',
		name: 'settings',
	},
	// {
	// 	title: 'Uitloggen',
	// 	url: '#',
	// 	name: 'logout',
	// 	items: []
	// }
];


// WEBPACK FOOTER //
// ./src/config/menu.js